import React from 'react';
import {
  MagicWand,
  Lightning,
  ArrowSquareOut,
  DownloadSimple,
  Trash,
} from '@phosphor-icons/react';

import previewApe from '../../assets/report-preview-ape.png';
import previewHarvard from '../../assets/report-preview-harvard.png';
import previewZoom from '../../assets/report-preview-zoom.png';

import { Button } from '../../components/general';
import { PageWrapper, ContentHeader } from '../../components/layout/content';

const Analytics = () => {
  const reports = [
    {
      preview: previewZoom,
      name: 'SSFC Campaign Infographics',
      link: 'https://drive.google.com/file/d/1tU3voC1qEdRP6JlEpa7xkK5Oulkwq84v/view?usp=sharing',
      isEnabled: true,
    },
    {
      preview: previewHarvard,
      name: 'SFFC X Zoom Event 2',
      link: '',
      isEnabled: false,
    },
    {
      preview: previewApe,
      name: 'SFFC X Zoom Event 3',
      link: '',
      isEnabled: false,
    },
  ];

  return (
    <PageWrapper type="user-dashboard" title="Analytics" className="gap-6">
      <ContentHeader
        title="Analytics"
        subtitle="Recent Campaign Infographics"
      />

      <table>
        <thead>
          <tr className="font-bold text-left">
            <th className="py-4">Preview</th>
            <th>Name</th>
            <th></th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {reports.map((report) => {
            return (
              <tr className="border-t border-grey-900 border-solid">
                <td className="w-72 py-4">
                  <img
                    className="w-52 rounded-md"
                    src={report.preview}
                    alt="Report Preview"
                  />
                </td>

                <td>{report.name}</td>

                <td>
                  {report.isEnabled ? (
                    <Button
                      variant="primary-thin"
                      colour="blue-green"
                      withGap
                      className="w-24"
                      onClick={() => window.open(report.link, '_blank')}
                    >
                      <MagicWand size="1.1rem" />
                      <div>Free</div>
                    </Button>
                  ) : (
                    <Button variant="primary-thin" withGap className="w-24">
                      <Lightning size="1.1rem" />
                      <div>Buy</div>
                    </Button>
                  )}
                </td>

                <td className="w-[calc((2.5rem_*_3)_+_(0.5rem_*_2))]">
                  <fieldset className="flex gap-2" disabled={!report.isEnabled}>
                    <Button variant="square" colour="light-grey-salmon">
                      <ArrowSquareOut />
                    </Button>

                    <Button variant="square" colour="light-grey-salmon">
                      <DownloadSimple />
                    </Button>

                    <Button variant="square" colour="light-grey-salmon">
                      <Trash />
                    </Button>
                  </fieldset>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </PageWrapper>
  );
};

export default Analytics;
